import CommonIntroductionBase from "./common/CommonIntroductionBase";

const WebSystemDevelopment = () => {
  return (
    <CommonIntroductionBase
      slide="Webデザインとシステムの作成"
      collectionName="websystemdevelopment"
      postTitle="Webデザイン情報"
      targetItems={["order", "title", "content", "image", "linkUrl"]}
      enableMarkdown
    />
  );
};

export default WebSystemDevelopment;
